import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';


export default function QuizResultsPage() {
  const [searchParams] = useSearchParams();
  const resultId = searchParams.get('id');

  if (!resultId) {
    return <p className="p-6 text-center text-gray-600">No result id provided.</p>;
  }
  return <Navigate to={`/result/${encodeURIComponent(resultId)}`} replace />;
}
